import React, { useEffect, useState } from "react";
import { get } from "util/requests";
import styles from "../../dashboard.module.css";
import Filters from "../../components/filters";
import KPI from "../../components/kpi";

export default function DataQualityDashboard(props) {
  const { params } = props;
  const [data, setData] = useState(null);

  useEffect(() => {
    get("/data_quality_kpis", { params: { ...params, study_id: 1 } }).then(({ data }) => {
      setData(data);
    });
  }, [params.filter, params.site, params.region]);
  return (
    <React.Fragment>
      <Filters {...props} params={params} />
      <div className={styles.row_align_top}>
        <div className={styles.split_100}>
          <div className={styles.kpi_row}>
            <KPI title={"Open Queries"} value={data?.open_queries} tall />
            <KPI title={"Responded Queries"} value={data?.responded_queries} tall />
            <KPI title={"Resolved Queries"} value={data?.resolved_queries} tall />
            <KPI tall />
          </div>
          <div className={styles.kpi_row}>
            <KPI title={"Day 30 Complete"} value={data?.day_30_complete} tall />
            <KPI title={"Day 90 Complete"} value={data?.day_90_complete} tall />
            <KPI tall />
            <KPI tall />
          </div>
          <div className={styles.kpi_row}>
            <KPI title={"Day 30 Monitored"} value={data?.day_30_monitored} tall />
            <KPI title={"Day 90 Monitored"} value={data?.day_90_monitored} tall />
            <KPI title={"Day 30 QC'd"} value={data?.day_30_qc} tall />
            <KPI title={"Day 90 QC'd"} value={data?.day_90_qc} tall />
          </div>
          <div className={styles.kpi_row}>
            <KPI title={"Site Signoff (by CRF)"} value={data?.site_signoff} tall />
            <KPI title={"Locked Data (by subject)"} value={data?.locked_data} tall />
            <KPI tall />
            <KPI tall />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
